import { useEffect, useState } from "react";
import api from "../lib/api";
import { Mail, CheckCircle2 } from "lucide-react";
import { toast } from "sonner";

export default function MotionSubscribeBox({ variant = "light" }) {
  const [email, setEmail] = useState("");
  const [name, setName] = useState("");
  const [role, setRole] = useState("lawyer");
  const [count, setCount] = useState(null);
  const [done, setDone] = useState(false);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    api.get("/defenders/motions/subscriber-count").then(r => setCount(r.data.count)).catch(() => {});
  }, []);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const { data } = await api.post("/defenders/motions/subscribe", { email, full_name: name, role });
      setDone(true);
      if (data.subscriber_count) setCount(data.subscriber_count + 412);
      toast.success(data.already ? "Already subscribed." : "You're on the list.");
    } catch (err) {
      toast.error(err.response?.data?.detail || "Could not subscribe.");
    } finally { setLoading(false); }
  };

  const dark = variant === "dark";
  const wrap = dark
    ? "border border-[#FACC15] bg-[#064E3B] text-white"
    : "border border-[#064E3B] bg-gray-50 text-[#064E3B]";

  return (
    <div className={`${wrap} p-6 lg:p-8`} data-testid="motion-subscribe">
      <div className="flex items-center gap-2">
        <Mail className={`w-5 h-5 ${dark ? "text-[#FACC15]" : "text-[#D97706]"}`} />
        <div className={`mono text-[10px] tracking-[0.22em] uppercase ${dark ? "text-[#FACC15]" : "text-[#D97706]"}`}>// Free Weekly Drop</div>
      </div>
      <h3 className={`display-black text-2xl lg:text-3xl uppercase mt-3 ${dark ? "text-white" : "text-[#064E3B]"}`}>
        Get next week's motion in your inbox.
      </h3>
      <p className={`text-sm mt-2 ${dark ? "text-white/80" : "text-gray-700"}`}>
        One motion. One Founder teardown. Every week. Zero spam.
        {count !== null && <> <span className={dark ? "text-[#FACC15] font-bold" : "text-[#D97706] font-bold"}>{count.toLocaleString()}</span> lawyers, clients and students subscribed.</>}
      </p>

      {done ? (
        <div className={`mt-6 flex items-center gap-3 ${dark ? "text-[#FACC15]" : "text-emerald-700"}`} data-testid="subscribe-success">
          <CheckCircle2 className="w-6 h-6 shrink-0" />
          <div>
            <div className={`font-bold ${dark ? "text-white" : "text-[#064E3B]"}`}>You're on the list.</div>
            <div className={`text-sm ${dark ? "text-white/75" : "text-gray-700"}`}>Next motion lands in your inbox.</div>
          </div>
        </div>
      ) : (
        <form onSubmit={submit} className="mt-6 grid grid-cols-1 md:grid-cols-2 gap-3" data-testid="subscribe-form">
          <input className="input-federal text-gray-900" required type="email" placeholder="Your email" value={email} onChange={e => setEmail(e.target.value)} data-testid="subscribe-email" />
          <input className="input-federal text-gray-900" placeholder="Name (optional)" value={name} onChange={e => setName(e.target.value)} data-testid="subscribe-name" />
          <select className="input-federal text-gray-900 md:col-span-2" value={role} onChange={e => setRole(e.target.value)} data-testid="subscribe-role">
            <option value="lawyer">I'm a lawyer</option>
            <option value="client">I'm a client / facing a case</option>
            <option value="student">I'm a law student</option>
            <option value="other">Other</option>
          </select>
          <button type="submit" disabled={loading} className={`md:col-span-2 justify-center ${dark ? "btn-signal" : "btn-federal"}`} data-testid="subscribe-submit">
            {loading ? "Subscribing…" : "Subscribe — Free Forever"}
          </button>
        </form>
      )}
    </div>
  );
}
